module.exports = __webpack_public_path__ + "img/calendar2-date.d1273b55.svg";